import axios from 'axios'
import {
  SiteModel,
  ResponseCRUD,
  ResponseObject,
  ResponseObjectPaginated,
  ResponseLocation,
  LocationModel,
  ResponseObjectURL,
  TableResumen,
} from '../model'

const BASEURL = process.env.REACT_APP_DEV_API_CENTRAL_URL
export function getSite(dto: SiteModel, page: number) {
  return axios.post<ResponseObjectPaginated<SiteModel[]>>(`${BASEURL}/site/getAll/${page}`, dto)
}

export function getSiteById(dto: any) {
  return axios.get<ResponseObject<SiteModel>>(`${BASEURL}/site/getInformationById?siteId=${dto}`)
}

export function createSite(dto: SiteModel) {
  return axios.post<ResponseCRUD>(`${BASEURL}/site/createSite`, dto)
}

export function deleteSite(dto: any) {
  return axios.delete<ResponseCRUD>(`${BASEURL}/site/deleteSite?id=${dto}`)
}

export function updateSite(dto: SiteModel) {
  return axios.put<ResponseCRUD>(`${BASEURL}/site/updateSite`, dto)
}

export function getTyPeDocumentSite(id: any) {
  return axios.post<any>(`${BASEURL}/site/GetTypeDocumentsSite?usuarioId=${id}`)
}
export function getDepartment() {
  return axios.get<ResponseLocation<LocationModel[]>>(`${BASEURL}/ubigee/getDepartments`)
}
export function getProvince(dto: string) {
  return axios.get<ResponseLocation<LocationModel[]>>(
    `${BASEURL}/ubigee/getProvince?departamentoId=${dto}`,
  )
}
export function getDistrict(dto: string) {
  return axios.get<ResponseLocation<LocationModel[]>>(
    `${BASEURL}/ubigee/getDistrict?provinciaId=${dto}`,
  )
}

// INICIO ---- SERVICIOS MASIVE

export function downloadTemplateSite() {
  return axios.post<ResponseObjectURL>(
    `${BASEURL}/site/downloadTemplateBulkLoad_file`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'arraybuffer',
    },
  )
}

export function uploadMasiveSite(dto: any) {
  return axios.post<ResponseObjectPaginated<TableResumen[]>>(`${BASEURL}/site/bulkLoad`, dto)
}

// FIN ---- SERVICIOS MASIVE
